/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var lastScrollTop = 0;

function debounce(method, delay) {
  clearTimeout(method._tId);
  method._tId= setTimeout(function(){
    method();
  }, delay);
}



var collectionFiltersWrapper = document.querySelector('.collection__toolbar');

function handlePageScrollForMobileHeader() {
  if(window.innerWidth < 640 && window.pageYOffset > 300) {
    var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    if (st > lastScrollTop){
      document.querySelector('.shopify-section-header').classList.add('fixed');
      if(collectionFiltersWrapper) {
       collectionFiltersWrapper.classList.add('fixed-collection-filters');
      }
    } else {
      document.querySelector('.shopify-section-header').classList.remove('fixed');
      if(collectionFiltersWrapper) {
        collectionFiltersWrapper.classList.remove('fixed-collection-filters');
      }
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  } else {
    // document.querySelector('.shopify-section-header').classList.remove('fixed');
  }
}

window.addEventListener("scroll", handlePageScrollForMobileHeader, false);

document.addEventListener('product:added', function(event) {
  document.querySelector('.shopify-section-header').classList.remove('fixed');
});


document.addEventListener('theme:loading:end', function(event) {
  collectionFiltersWrapper = document.querySelector('.collection__toolbar');
});



// Zoorix logic

document.addEventListener("zrx-loaded", function (e) {
  if (e.type === 'zrx-loaded') {
    const checkboxes = document.querySelectorAll('[data-bundle-id] .zrx-checkbox input');
    checkboxes.forEach((c, index) => {
      if (index !== 0) {
        if (c.click) {
          c.click.apply(c);
        }
      }
    });
  }
});



const selectVariantByClickingImage = {
  // Create variant images from productJson object
  _createVariantImage: function (product) {
    const variantImageObject = {};
    product.variants.forEach((variant) => {
      if (
        typeof variant.featured_image !== 'undefined' &&
        variant.featured_image !== null
      ) {
        const variantImage = variant.featured_image.src
          .split('?')[0]
          .replace(/http(s)?:/, '');
        variantImageObject[variantImage] =
          variantImageObject[variantImage] || {};
        product.options.forEach((option, index) => {
          const optionValue = variant.options[index];
          const optionKey = `option-${index}`;
          if (
            typeof variantImageObject[variantImage][optionKey] === 'undefined'
          ) {
            variantImageObject[variantImage][optionKey] = optionValue;
          } else {
            const oldValue = variantImageObject[variantImage][optionKey];
            if (oldValue !== null && oldValue !== optionValue) {
              variantImageObject[variantImage][optionKey] = null;
            }
          }
        });
      }
    });
    return variantImageObject;
  },
  _updateVariant: function (event, id, product, variantImages) {
    const arrImage = event.target.src
      .split('?')[0]
      .replace(/http(s)?:/, '')
      .split('.');
    const strExtention = arrImage.pop();
    const strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/, '');
    const strNewImage = `${arrImage.join('.')}.${strRemaining}.${strExtention}`;
    if (typeof variantImages[strNewImage] !== 'undefined') {
      product.variants.forEach((option, index) => {
        const optionValue = variantImages[strNewImage][`option-${index}`];
        if (optionValue !== null && optionValue !== undefined) {
          const selects = document.querySelectorAll('#'+ id + ' [class*=single-option-selector]');
          const options = selects[index].options;
          for (let option, n = 0; (option = options[n]); n += 1) {
            if (option.value === optionValue) {
              selects[index].selectedIndex = n;
              selects[index].dispatchEvent(new Event('change'));
              break;
            }
          }
        }
      });
    }
  },
  _selectVariant: function() {
    const productJson = document.querySelectorAll('[id^=ProductJson-');
    if (productJson.length > 0) {
      productJson.forEach((product) => {
        const sectionId = product.id.replace("ProductJson-", "shopify-section-");
        const thumbnails = document.querySelectorAll('#'+ sectionId + ' img[src*="/products/"]');
        if (thumbnails.length > 1) {
          const productObject = JSON.parse(product.innerHTML);
          const variantImages = this._createVariantImage(productObject);
          // need to check variants > 1
          if (productObject.variants.length > 1) {
            thumbnails.forEach((thumbnail) => {
              thumbnail.addEventListener('click', (e) =>
                this._updateVariant(e, sectionId, productObject, variantImages),
              );
            });
          }
        }
      });
    }
  },
};
if (document.readyState !== 'loading') {
  selectVariantByClickingImage._selectVariant();
} else {
  document.addEventListener(
    'DOMContentLoaded',
    selectVariantByClickingImage._selectVariant(),
  );
}


document.addEventListener("DOMContentLoaded", function(){
  thumbnails =  document.querySelectorAll('img[src*="/products/"]');
  function addEventListenerList(thumbnails) {
    for (var i = 0, len = thumbnails.length; i < len; i++) { 
      console.log(thumbnails[i].currentSrc);
      	thumbnails[i].addEventListener('click', thumbImageSwap, false);
    }
  }
  
  function thumbImageSwap(){
    var arrImage 		= this.getAttribute('src').split('?')[0].split('.');
    var strExtention 	= arrImage.pop();
    var strRemaining 	= arrImage.pop().replace(/_[a-zA-Z0-9@]+$/,'');
    var strNewImage		= arrImage.join('.')+"."+strRemaining+"."+strExtention;

    productOptions.forEach(function (value, i) {
      if (typeof(variantImages[strNewImage]) != 'undefined') {
        optionValue = variantImages[strNewImage]['option-'+i];
        optionSelector = document.getElementById('SingleOptionSelector-'+i);
        optionSelectorArray = Array.apply(null, optionSelector);
        if (optionValue !== null && optionSelectorArray.filter(function(el) {return el.innerText.trim() === optionValue }).length ) {      
            optionSelector.value = optionValue;
            optionSelector.dispatchEvent(new Event('change', {option: optionSelector.value}));
         }  
        }  
    });
  }
  
  addEventListenerList(thumbnails);
});